import { post, get, put, del, upload } from '@api/request';

export async function fetchEconUnitCodes(
  { assessmentService, appraisalService },
  authenticationToken,
  { codeType, name, year },
) {
  if(name === 'School Code') {
    const url = `${assessmentService}/assessment/taxingunitssummary`;
    let { body } = await get(authenticationToken, url);
    if (body && body.results && body.results.length > 0) {
      body.results = body.results.filter(d => d.taxingUnitType === 'School').map(item => ({
        codeName: item.taxingUnitCode,
        codeDescription: item.taxingUnitName,
      }));
    }
    return body;
  } else {
    let url = `${appraisalService}/appraisal/codes?type=${codeType}&name=${name}`;
    if (year) {
      url += `&year=${year}`;
    }
    const { body } = await get(authenticationToken, url);
    return body;
  }
}

export async function addEconUnitPropertyValuation(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/propertyvaluation`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function setEconUnitPropertyValuation(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/setvaluetype`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function searchEconomicUnits(
  { appraisalService },
  authenticationToken,
  { payload, page, pageSize },
) {
  let url = `${appraisalService}/appraisal/economicunit/search?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function searchEconomicStandalone(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  let url = `${appraisalService}/appraisal/economicunit/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchEconomicUnit(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchConfigs(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/economicunitsearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createEconomicUnit(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/economicunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateEconomicUnit(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/summary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function insertEconomicUnitPropertyUse(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/propertyuses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchCodeFile(
  { appraisalService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchIncomeCalculationRule(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/income/actuals/additionalincomecalculationtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExpenseCalculationRule(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/income/actuals/expensecalculationtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchLeasingConcessionsCalculationRule(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/income/actuals/leasingconcessionscalculationtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchReimbursedExpenseCalculationRule(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/income/actuals/reimbursedexpensecalculationtype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchIncomeRateTypes(
  { appraisalService },
  authenticationToken,
) {
  let url = `${appraisalService}/appraisal/income/ratetype`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitDataInputs(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/datainput`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createEconomicUnitProperty(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchEconomicUnitProperties(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteEconomicUnitProperties(
  { appraisalService },
  authenticationToken,
  { econPropId },
) {
  let url = `${appraisalService}/appraisal/economicunitproperty/${econPropId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteEconomicUnit(
  { appraisalService },
  authenticationToken,
  { econID, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econID}/${pYear}/${pVersion}/${pRollCorr}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitSearchParams(
  { appraisalService },
  authenticationToken,
  { userName },
) {
  const queryParam = userName ? `?userName=${userName}` : '';
  const url = `${appraisalService}/appraisal/economicunit/searchparameters${queryParam}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertEconomicUnitSearchParam(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/economicunit/searchparameters`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchEconomicUnitPropertyUses(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/propertyuses`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitRentRolls(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/rentrollsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitPropertyUse(
  { appraisalService },
  authenticationToken,
  { econPropUseId, payload },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function refreshEconomicUnitLand(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/refreshland`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function refreshEconomicUnitPropertyUseImprovement(
  { appraisalService },
  authenticationToken,
  { econPropUseId, payload },
) {
  let url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseId}/refreshimprovement`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteEconomicUnitPropertyUse(
  { appraisalService },
  authenticationToken,
  { econPropUseId },
) {
  let url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID, payload },
) {
  const url = `${appraisalService}/appraisal/economicunit/searchparameter/${searchParamID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteEconomicUnitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/economicunit/searchparameter/${searchParamID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateEconomicUnitSearchParam(
  { appraisalService },
  authenticationToken,
  { searchParamID },
) {
  const url = `${appraisalService}/appraisal/economicunit/searchparameter/${searchParamID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitSearchConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/economicunitsearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitEvents(
  { eventService },
  authenticationToken,
  { econId },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${econId}`,
    dataObject: 'economic unit',
  });
  return body;
}

export async function fetchEconomicUnitFormOptions(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/peventforms?dataObject=economic unit`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitIncomeValuations(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/valuations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchValidApproaches(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/income/approaches`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createEconomicUnitIncomeValuation(
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) {
  const url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/` +
    `${pRollCorr}/valuations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchIncomeDirectCap(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcap/${pIncomeId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateIncomeDirectCap(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  let url = `${appraisalService}/appraisal/incomedirectcap/${pIncomeId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchIncomeDirectCapActuals(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function recalculateDirectCapActuals(
  { recalculationService },
  authenticationToken,
  { payload },
) {
  let url = `${recalculationService}/recalc/directcapactuals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateIncomeDirectCapActuals(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchIncomeDirectActualsPropertyUses(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/propertyuses`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertIncomeDirectActualsPropertyUse(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/propertyuses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteIncomeDirectActualsPropertyUse(
  { appraisalService },
  authenticationToken,
  { pPropertyUseId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/propertyuse/${pPropertyUseId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateIncomeDirectActualsPropertyUse(
  { appraisalService },
  authenticationToken,
  { pPropertyUseId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/propertyuse/${pPropertyUseId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchIncomeDirectActualsExpenses(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/expenses`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertIncomeDirectActualsExpense(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/expenses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteIncomeDirectActualsExpense(
  { appraisalService },
  authenticationToken,
  { pExpenseId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/expense/${pExpenseId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateIncomeDirectActualsExpense(
  { appraisalService },
  authenticationToken,
  { pExpenseId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/expense/${pExpenseId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchIncomeDirectActualsAddlIncome(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/additionalincome`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertIncomeDirectActualsAddlIncome(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/additionalincome`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateIncomeDirectActualsAddlIncome(
  { appraisalService },
  authenticationToken,
  { pAddIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/additionalincome/${pAddIncomeId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteIncomeDirectActualsAddlIncome(
  { appraisalService },
  authenticationToken,
  { pAddIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/additionalincome/${pAddIncomeId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicateIncomeDirectCapActual(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchIncomeDirectActualsAddlIncomeEGI(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactualsegi/${pIncomeId}/additionalincome`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertIncomeDirectActualsAddlIncomeEGI(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactualsegi/${pIncomeId}/additionalincome`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateIncomeDirectActualsAddlIncomeEGI(
  { appraisalService },
  authenticationToken,
  { pAddIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactualsegi/additionalincome/${pAddIncomeId}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteIncomeDirectActualsAddlIncomeEGI(
  { appraisalService },
  authenticationToken,
  { pAddIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactualsegi/additionalincome/${pAddIncomeId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitNotes(
  { appraisalService },
  authenticationToken,
  { econID, query },
) {
  const url = `${appraisalService}/appraisal/economicunit/${econID}/notes${
    query ? `?${query}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addEconomicUnitNote(
  { appraisalService },
  authenticationToken,
  { econID, data },
) {
  const url = `${appraisalService}/appraisal/economicunit/${econID}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deleteEconomicUnitNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/economicunitnote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/economicunitnote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateEconomicUnitNoteTags(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/economicunitnote/${noteId}/tags`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export const insertEconomicUnitFile = async (
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteEconomicUnitFile = async (
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, s3ID, payload },
) => {
  const url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadEconomicUnitFile = async (
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, s3ID },
) => {
  const url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updateEconomicUnitFile = async (
  { appraisalService },
  authenticationToken,
  { pYear, econId, pVersion, pRollCorr, payload },
) => {
  const url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const recalculateEconomicUnit = async (
  { recalculationService },
  authenticationToken,
  { econId, pYear, pVersion = 0, pRollCorr = 0 },
) => {
  const url =
    `${recalculationService}/recalc/economicunit/${econId}/${pYear}/` +
    `${pVersion}/${pRollCorr}`;
  const { body } = await post(authenticationToken, url, {});
  return body;
};

export async function deleteDirectCapModel(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcap/${pIncomeId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteDirectCapActuals(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitPropertyValuations(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/includedvaluations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function includeEconomicUnitPropertyValuation(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/includedvaluations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function excludeEconomicUnitPropertyValuation(
  { appraisalService },
  authenticationToken,
  { econIncludedValuationId },
) {
  let url = `${appraisalService}/appraisal/economicunit/includedvaluation/${econIncludedValuationId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitReconcile(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/reconcile`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitReconcile(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/reconcile`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchEconomicUnitAllocate(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/allocate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitAllocate(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/allocate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchEconomicUnitDistribution(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/distribution`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateEconomicUnitDistribution(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr, payload },
) {
  let url =
    `${appraisalService}/appraisal/economicunit/${econId}/${pYear}` +
    `/${pVersion}/${pRollCorr}/distribution`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateIncomeDirectActualsName(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  let url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/updatename`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateMarketAreaTaxRate(
  { appraisalService },
  authenticationToken,
  { econId, pYear, pVersion, pRollCorr },
) {
  let url = `${appraisalService}/appraisal/economicunit/${econId}/${pYear}/${pVersion}/${pRollCorr}/marketareataxrateupdate`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function fetchPropUseRentRolls(
  { appraisalService },
  authenticationToken,
  { econPropUseID },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseID}/rentrolls`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPropUseRentRoll(
  { appraisalService },
  authenticationToken,
  { econPropUseID, payload },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseID}/rentrolls`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePropUseRentRoll(
  { appraisalService },
  authenticationToken,
  { rentRollID, payload },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/rentroll/${rentRollID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deletePropUseRentRoll(
  { appraisalService },
  authenticationToken,
  { rentRollID },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/rentroll/${rentRollID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPropUseRentRollSummary(
  { appraisalService },
  authenticationToken,
  { econPropUseID },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseID}/rentrollsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropUseRentRollSummary(
  { appraisalService },
  authenticationToken,
  { econPropUseID, payload },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseID}/rentrollsummary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function calculatePropUseRentRoll(
  { appraisalService },
  authenticationToken,
  { econPropUseID, payload },
) {
  const url = `${appraisalService}/appraisal/economicunitpropertyuse/${econPropUseID}/calculaterentroll`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function copyModelToActuals(
  { appraisalService },
  authenticationToken,
  { econID, pYear, pRollCorr, pVersion, payload },
) {
  const url = `${appraisalService}/appraisal/economicunit/${econID}/${pYear}/${pRollCorr}/${pVersion}/copymodeltoactuals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchOverrideRentSummary(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/overriderentsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOverrideRentRateTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/overriderents/ratetypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOverrideRents(
  { appraisalService },
  authenticationToken,
  { pIncomeId },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/overriderents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertOverrideRent(
  { appraisalService },
  authenticationToken,
  { pIncomeId, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/${pIncomeId}/overriderents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteOverrideRent(
  { appraisalService },
  authenticationToken,
  { overrideRentID },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/overriderent/${overrideRentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateOverrideRent(
  { appraisalService },
  authenticationToken,
  { overrideRentID, payload },
) {
  const url = `${appraisalService}/appraisal/incomedirectcapactuals/overriderent/${overrideRentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchEcoRevisionHistory(
  { appraisalService },
  authenticationToken,
  { ecoUnitID },
) {
  const url = `${appraisalService}/appraisal/revisionhistory/ecounit/${ecoUnitID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}